import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { createOutsideClickListener } from 'utils';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './Navigation.css';

import Mobile from './Mobile';
import Desktop from './Desktop';

const dumbNavigation = dumbBem('landing-nav');
const NavigationWrp = tx(dumbNavigation)('div');

export class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onTop: false,
      isOpened: false,
    };

    _.bindAll(this, [
      'handleScroll',
      'toggleOpen',
      'closeMenu',
    ]);
  }

  componentDidMount() {
    this.addScrollListener();
    this.addClickOutsideMenuListener();
  }

  componentWillUnmount() {
    this.removeScrollListener();
    this.removeClickOutsideListener();
  }

  addScrollListener() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  removeScrollListener() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  addClickOutsideMenuListener() {
    const mobileNav = window.document.querySelector('.landing-nav--mobile');
    if (!mobileNav) return false;

    this.clickOutsideMenuListener = createOutsideClickListener(mobileNav, this.closeMenu);
    window.document.body.addEventListener('click', this.clickOutsideMenuListener);
  }

  removeClickOutsideListener() {
    if (this.clickListener) window.document.body.removeEventListener('click', this.clickListener);
  }

  closeMenu() {
    if (this.state.isOpened) this.toggleOpen();
  }

  handleScroll() {
    if (window.scrollY > 10) {
      if (!this.state.onTop) this.setState({ onTop: true });
    } else if (this.state.onTop) {
      this.setState({ onTop: false });
    }
  }

  toggleOpen() {
    this.setState(prevState => ({ isOpened: !prevState.isOpened }));
  }

  render() {
    const { isOpened, onTop } = this.state;
    const { isMobile } = this.props;
    const modifiers = [];

    if (isMobile) modifiers.push('mobile');
    if (isMobile && isOpened) modifiers.push('opened');
    if (onTop) modifiers.push('float');

    return (
      <NavigationWrp modifier={modifiers.join(' ')}>
        <div className="landing-nav__container">
          {isMobile && <Mobile isOpened={isOpened} toggleOpen={this.toggleOpen} />}
          {!isMobile && <Desktop />}
        </div>
      </NavigationWrp>
    );
  }
}

Navigation.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/landing/components/navigation/Navigation.jsx